import { render, staticRenderFns } from "./LayoutRegister.vue?vue&type=template&id=32d77d61&scoped=true"
import script from "./LayoutRegister.vue?vue&type=script&lang=js"
export * from "./LayoutRegister.vue?vue&type=script&lang=js"
import style0 from "./LayoutRegister.vue?vue&type=style&index=0&id=32d77d61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d77d61",
  null
  
)

export default component.exports